import type * as React from "react";

interface CustomCheckIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export function CustomCheckIcon({ className, ...props }: CustomCheckIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-label="Selected"
      {...props}
    >
      <path
        d="M12.4767 4.46266C12.7732 4.17376 13.2481 4.18008 13.5373 4.47633C13.8262 4.77276 13.8199 5.24768 13.5236 5.53688L6.52459 12.3699C6.37849 12.5125 6.17984 12.5894 5.97577 12.5828C5.77183 12.5761 5.57908 12.4864 5.44256 12.3347L2.44256 9.00172C2.16546 8.69386 2.19038 8.21926 2.49823 7.94215C2.80609 7.66505 3.28068 7.68997 3.5578 7.99781L6.03534 10.7507L12.4767 4.46266Z"
        fill="white"
      />
    </svg>
  );
}
